import { render, staticRenderFns } from "./studentAlbumRecord.vue?vue&type=template&id=1ca4e196&scoped=true&"
import script from "./studentAlbumRecord.vue?vue&type=script&lang=js&"
export * from "./studentAlbumRecord.vue?vue&type=script&lang=js&"
import style0 from "./studentAlbumRecord.vue?vue&type=style&index=0&id=1ca4e196&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca4e196",
  null
  
)

export default component.exports